// The addresses of the two full-page work screens (slugs, versions and file paths only; never personal data).

/**
 * The playground on a version and, optionally, on one file (`src/api/v2/dedupe.js`). BP-1: `product` = whose batch
 * (`banxx.personal`; null = the whole-lender batch, `p=lender`); left out = any of the lender's.
 */
export function playgroundUrl(slug: string, version?: string, file?: string, product?: string | null): string {
  const q = new URLSearchParams()
  if (product !== undefined) q.set('p', product ?? 'lender')
  if (version) q.set('v', version)
  if (file) q.set('file', file)
  const s = q.toString()
  return `/lenders/${slug}/playground${s ? `?${s}` : ''}`
}

/** The canvas of one workflow version. */
export const workflowUrl = (slug: string, wfId: string) => `/lenders/${slug}/workflows/${wfId}`
